import { SocialLinkType } from '../../FooterBottom/types/Socials.types.js';

// { link: 'https://www.instagram.com/sravni.ru/', type: SocialLinkType.INSTAGRAM },
// { link: 'https://www.facebook.com/Sravni.ru', type: SocialLinkType.FACEBOOK },
const defaultSocialLinks = [
    {
        text: SocialLinkType.TELEGRAM,
        href: 'https://t.me/sravni_tg',
        customStyle: '',
        isLink: true,
        nofollow: true,
        noindex: true,
        openInNew: true,
        icon: '',
        iconSrc: '',
        isTextVisible: false,
        children: [],
        noReferrer: false,
    },
    {
        text: SocialLinkType.VK,
        href: 'https://vk.com/sravni',
        customStyle: '',
        isLink: true,
        nofollow: true,
        noindex: true,
        openInNew: true,
        icon: null,
        iconSrc: null,
        isTextVisible: false,
        children: [],
        noReferrer: false,
    },
    {
        text: SocialLinkType.VIBER,
        isTextVisible: false,
        icon: '',
        iconSrc: '',
        href: 'https://vb.me/sravni',
        customStyle: '',
        isLink: true,
        openInNew: true,
        noindex: true,
        nofollow: true,
        children: [],
        noReferrer: false,
    },
    {
        text: SocialLinkType.OK,
        isTextVisible: true,
        icon: '',
        iconSrc: '',
        href: 'https://ok.ru/sravni',
        customStyle: '',
        isLink: true,
        openInNew: true,
        noindex: true,
        nofollow: true,
        children: [],
        noReferrer: false,
    },
    {
        text: SocialLinkType.DZEN,
        isTextVisible: true,
        icon: '',
        iconSrc: '',
        href: 'https://zen.yandex.ru/sravni.ru',
        customStyle: '',
        isLink: true,
        openInNew: true,
        noindex: true,
        nofollow: true,
        children: [],
        noReferrer: false,
    },
];

export { defaultSocialLinks };
//# sourceMappingURL=socialLinks.js.map
